import { Copy, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

const badge = 'inline-flex items-center gap-[5px] whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold';

/**
 * « N équipes concernées » (ADR-009, screens 07, 08, 09): team of the request
 * and every team of its subscribers, computed by the API.
 * TODO(VALIDATE teams-concerned-display): shown from 2 teams, as the mock-ups only show it on some
 * rows; one team is the ordinary case.
 */
export function TeamsConcernedBadge({ count, className }: { count: number; className?: string }) {
  if (count < 2) return null;
  return (
    <span className={cn(badge, 'border border-input bg-card text-foreground-secondary', className)}>
      <Users aria-hidden="true" className="size-[13px]" />
      {count} équipes concernées
    </span>
  );
}

/** « Doublon probable · PP-305 »: suggested on screen 16, the requester answered « C'est différent ». */
export function ProbableDuplicateBadge({ reference, className }: { reference: string; className?: string }) {
  return (
    <span className={cn(badge, 'border border-warning-border bg-warning text-warning-foreground', className)}>
      <Copy aria-hidden="true" className="size-[13px]" />
      Doublon probable · {reference}
    </span>
  );
}
